import { useEffect } from 'react'
import { useGetScheduleShipmentsStore } from '../store/getScheduleShipmentsStore'
import { useGetScheduleTopupStore } from '../store/getScheduleTopupStore'
import { useInvoicesStore } from '../store/invoicesStore'
import { useCurrentAccountStore } from '../store/currentAccountStore'
import { useReportVouchersSentStore } from '../store/reportVouchersSentStore'
import { useVisibilityByBeneficiaryStore } from '../store/visibilityByBeneficiaryStore'
import { useWalletExpiredBalanceStore } from '../store/walletExpiredBalanceStore'
import useRouteHistory from '../hooks/useRouteHistory'
import { usePurchaseFrequencyStore } from '../store/purchaseFrequencyStore'

export const ResetStoresOnRouteChange = ({ children }) => {
  const routeHistory = useRouteHistory()
  const resetStores = () => {
    useGetScheduleShipmentsStore.getState().resetStore()
    useGetScheduleTopupStore.getState().resetStore()
    useInvoicesStore.getState().resetStore()
    useCurrentAccountStore.getState().resetStore()
    useReportVouchersSentStore.getState().resetStore()
    useVisibilityByBeneficiaryStore.getState().resetStore()
    useWalletExpiredBalanceStore.getState().resetStore()
    usePurchaseFrequencyStore.getState().resetStore()
  }

  useEffect(() => {
    if (routeHistory.length > 1) {
      resetStores()
    }
  }, [routeHistory])

  return children
}
